import {DELETE_GROUP_NEWS_START} from "../../types";

export const delete_group_news = (payload) => ({
    type: DELETE_GROUP_NEWS_START,
    payload,
});
